// extracted by mini-css-extract-plugin
export var divider = "_1l-0";
export var dividerText = "_1l-1";